import { defaultInventario } from './state';
import { getAcls } from '../../../plugins/acl';

/**
 * Mutación que carga la información del inventario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} inventario contiene la información del inventario.
 */
export function setInventario(state, inventario) {
    state.inventario = inventario.data;
}

export function setInventariosProcesados(state, inventarioProc) {
    state.inventariosProcesados = inventarioProc;
}

/**
 * Mutación para asignar el uuid del usuario al agendamiento de inventarios.
 *
 * @export
 * @param {*} state
 */
export function setUuid(state) {
    const acls = getAcls();

    if (acls && acls.uuid) {
        Object.assign(state.selectedInventario, { uuid: acls.uuid })
    }
}

/**
 * Mutación para asignar el reporte mys.
 *
 * @export
 * @param {*} state
 * @param {*} data
 */
export function setReporteMys(state, data) {
    state.selectedInventario.mys = data.mys;
}

/**
 * Mutación que carga las empresas al inventario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} optempresa contiene la información de las empresas.
 */
export function cargarEmpresas(state, optempresa) {

    state.optempresa = [];

    for (var i = 0; i < optempresa.length; i++) {
        state.optempresa.push({ value: optempresa[i].id, text: optempresa[i].nombre });
    }
}

/**
 * Mutación que carga las bases del inventario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} optbases contiene la información de las bases.
 */
export function cargarBases(state, optbases) {

    state.optbases = [];

    state.optbases.push({ value: '', text: '' });

    for (var i = 0; i < optbases.length; i++) {
        state.optbases.push({ value: optbases[i].id, text: optbases[i].descripcion });
    }
}

/**
 * Mutación que carga las áreas del inventario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 * @param {*} optareas contiene la información de las áreas.
 */
export function cargarAreas(state, optareas) {

    state.optareas = [];

    state.optareas.push({ value: '', text: '' });

    for (var i = 0; i < optareas.length; i++) {
        state.optareas.push({ value: optareas[i].id, text: optareas[i].descripcion });
    }
}

/**
 * Mutación para almacenar las empresas obtenidas.
 *
 * @export
 * @param {*} state
 * @param {*} data
 */
export function setEmpresas(state, data) {
    state.listaEmpresas = data;
}

/**
 * Mutación que limpia la empresa del inventario.
 *
 * @param {*} state contiene la informacion de variables del formulario.
 */
export function limpiaEmpresa(state) {
    state.selectedInventario.ubicaciones = [];
    state.ubicEmpresa = [];
    state.selectedInventario.empresa = '';
}

/**
 * Mutación para cargar la informacion de productos químicos.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} empresa contiene la información de la busqueda.
 */
export function setUbicacioneEmpresa(state, ubicaciones) {
    state.ubicEmpresa = []
    state.ubicEmpresa = ubicaciones

}

/**
* Mutación para cargar la informacion de productos químicos.
*
* @param {*} state contiene la información de variables del formulario.
* @param {*} empresa contiene la información de la busqueda.
*/
export function setFiltroUbicacion(state, ubicaciones) {
    state.selectedInventario.ubicaciones = ubicaciones
}

export function setContratistas(state, contratistas) {
    state.contratistas = contratistas
}

export function resetSelectedInventario(state) {
    state.selectedInventario = defaultInventario()
}

export function resetUbiEmpresa(state) {
    state.ubicEmpresa = []
}

export function setEmpresa(state, empresa) {
    state.empresa = empresa
}

/**
 * Mutación para cargar la informacion en segundo plano.
 *
 * @param background_process Informacion de procesos.
 */
export function setBackgroundProcess(state, background_process) {
    state.background_process = background_process
}
